/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_2_AnswerInputs */

const en_svc_research_faq_2_answer = /** @type {(inputs: Svc_Research_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. It can combine public sources with your CRM, documents or databases, using only the access its task needs.`)
};

const lv_svc_research_faq_2_answer = /** @type {(inputs: Svc_Research_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. Tas var apvienot publiskus avotus ar Jūsu CRM, dokumentiem vai datubāzēm, izmantojot tikai uzdevumam vajadzīgo piekļuvi.`)
};

/**
* | output |
* | --- |
* | "Yes. It can combine public sources with your CRM, documents or databases, using only the access its task needs." |
*
* @param {Svc_Research_Faq_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_2_answer = /** @type {((inputs?: Svc_Research_Faq_2_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_2_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_2_answer(inputs)
	return en_svc_research_faq_2_answer(inputs)
});